// src/App.tsx
import React from 'react'
import {Routes, Route, Navigate} from 'react-router-dom'

// Pages
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Users from './pages/Users'
import Transactions from './pages/Transactions'
import Settings from './pages/Settings'
import Notifications from './pages/Notifications'
import Profile from './pages/Profile'
import AddUser from './pages/Users/AddUser'

// ===== Admin Pages (جديد) =====
import LegalEditor from './pages/admin/LegalEditor'

// Components
import InstallBanner from './components/InstallBanner'

// Services
import {isAuthenticated} from './services/api'

// ===== Types =====
interface ProtectedRouteProps {
    children: React.ReactNode
}

interface PublicRouteProps {
    children: React.ReactNode
}

// ===== Route Guards =====
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({children}) => {
    const authenticated = isAuthenticated()
    console.log('🔒 Protected Route - Authenticated:', authenticated)

    if (!authenticated) {
        console.log('🚫 Not authenticated, redirecting to login')
        return <Navigate to="/login" replace />
    }
    return <>{children}</>
}

const PublicRoute: React.FC<PublicRouteProps> = ({children}) => {
    const authenticated = isAuthenticated()
    console.log('🔓 Public Route - Authenticated:', authenticated)

    if (authenticated) {
        console.log('✅ Already authenticated, redirecting to dashboard')
        return <Navigate to="/dashboard" replace />
    }
    return <>{children}</>
}

// ===== Main App Component =====
const App: React.FC = () => {
    console.log('🚀 App rendered')

    return (
        <>
            <InstallBanner />
            <Routes>
                {/* Public Routes */}
                <Route
                    path="/login"
                    element={
                        <PublicRoute>
                            <Login />
                        </PublicRoute>
                    }
                />

                {/* Protected Routes */}
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/users"
                    element={
                        <ProtectedRoute>
                            <Users />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/users/add"
                    element={
                        <ProtectedRoute>
                            <AddUser />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/transactions"
                    element={
                        <ProtectedRoute>
                            <Transactions />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/settings"
                    element={
                        <ProtectedRoute>
                            <Settings />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/notifications"
                    element={
                        <ProtectedRoute>
                            <Notifications />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/profile"
                    element={
                        <ProtectedRoute>
                            <Profile />
                        </ProtectedRoute>
                    }
                />

                {/* ===== Admin Routes (جديد) ===== */}
                <Route
                    path="/admin/legal"
                    element={
                        <ProtectedRoute>
                            <LegalEditor />
                        </ProtectedRoute>
                    }
                />

                {/* Redirects */}
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
        </>
    )
}

export default React.memo(App)